export enum MenuItemCategory {
    Default = "default",
    Heading = "heading",
    Person = "person",
    Matter = "matter",
    Contract = "contract",
    Property = "property",
    TitleInsurance = "titleins",
    LawyerList = "lawyerlist",
    AdditionalParties = "additionalparties",
    Alert = 'alert',
    Blank = 'blank',
    Dropdown = 'dropdown',
    WindowOpen = 'windowopen',
}

export type NavObjectType = {
    component: string,
    url?: string | 1 | -1,
    params?: Record<string, string>,
    popup?: boolean,
    popupStyle?: "small" | "medium" | "large" | "xlarge" | "settings" | "inframe",
    isModal?: boolean
    windowState?: unknown
    controller?: TabController;
    action?: string;
    actionParam?: [string | number] | string | number | object;
    callback?: (...args: any[]) => void | NavObjectType;
    redirect?: boolean;
    label?: string; // Label for highlighting side drawer
    init?: boolean;
    scrollToId?: string;
    reactFrame?: string,
    tabName?: TabNames;
    tabNumber?: number;
}
export type NavObjectWinState = {
    ShellInitFunc?: Function,
    dialogArguments?: {
        livedataRoot?: any,
        liveformPopupDataNode?: any,
        datalockobj?: any,
    } | any;
}

export type TabController = purfileController;
export type TabNames = "Basic" | "Issues" | "Mortgages" | "Title Insurance" | "Financial" | "Documents" | "Registrations" | "Client Portal"
export type ComponentList = "FireInsurer" | "PurchaserRealEstateBroker" | "RealEstateBroker" | "Conveyancer" | "MortgageBroker" | "MortgageLender" | "DischargeLender" | "OtherParty"
export enum PopupPageId {
    None = 'Default',
    Transferee = 'TransfereeDetails',
    Transferor = 'TransferorDetails',
    Solicitor = 'Solicitor',
    InsuranceAgent = 'InsuranceAgent',
    MortgageBroker = 'MortgageBroker',
    Conveyancer = 'Conveyancer',
    RealEstateAgent = 'RealEstateAgent',
    PurchaserRealEstateAgent = 'PurchaserRealEstateAgent',
    MortgageID = 'MortgageIdDetails',
    OtherParty = 'OtherParty',
}

export enum ScreenActions {
    setVTB = 1,
    setTransferEstate = 2,
    setTransferCorporation = 3,
    setMortgageInbox = 4,
    setTransferIndividual = 5,
    openCloudDrive = 6,
    setOtherPartyType = 7,
}
export type purfileController = {
    tabName?: TabNames | PopupPageId,
    tabNumber?: number,
    refresh?: boolean,
    autoClick?: string,
    screenAction?: ScreenActions,
    onClickDispatch?: ComponentList,
    onClickDispatchPayload?: Record<string, string>,
    autoClickClassName?: string,
    autoClickClassNamePosition?: number,
}

export type jsxParams = {
    variant: string,
    jsx: {
        tag: 'span' | 'b',
        text: string
    }[]
}

export type MenuItemType = {
    eventKeyPrefix?: string,
    id?: string,
    label: string,
    navigate: NavObjectType,
    type: MenuItemCategory,
    addOptions: Array<MenuItemType>,
    expandable?: boolean,
    maxSize?: number,
    params?: Record<string, string>,
    jsxParams?: jsxParams,
    subItems?: Array<MenuItemType>,
    PSM?: string
    appCode?: Array<AppCodes>,
    dropdownOptions?: Array<MenuItemType>,
    requiredFields?: FieldCondition[],
    symbol?: "copyright" | "trademark" | "registered",
}

export type FieldCondition = {
    field: string,
    value?: string
}

export type Provinces = "Ontario" | "Alberta" | "Saskatchewan" | "Manitoba" | "British Columbia" | "Nova Scotia"
export type CountryCodes = "CA" | "US"
export type AppCodes = "RPW" | "RPWAB" | "RPWNS" | "RPWSK" | "RPWMB" | "RPWBC" | "DS"
export type ProvincesShortCode = "SK" | "ON" | "NS" | "MB" | "AB" | "BC"
export type lddGlobalSessionInfo = {
    sid: string,
    appCode: AppCodes,
    appCountry: CountryCodes,
    appProvince: Provinces,
    appProvinceShort: ProvincesShortCode,
    user: lddGlobalSessionUserInfo
    firm: lddGlobalSessionFirmInfo
    MSLoginEmail: string,
    accounts?: [
        {
            account: string,
            name: string,
            id: string
        }
    ],
    isLDDUser?: boolean
}
export type lddGlobalSessionUserInfo = {
    isAdmin: boolean
    account: string,
    email: string,
    firstname: string,
    lastname: string,
    fullname: string,
    initials: string,
    id: number,
    phone: string,
    cell: string
}
export type lddGlobalSessionFirmInfo = {
    account: string,
    name: string
    id: number
    phone: string,
    fax: string,
    email: string,
    city: string,
    postalcode: string,
    address: string,
    province: string,
    Lawyers: lddGlobalSessionLawyerInfo[],
    Staffs: lddGlobalSessionStaffInfo[],
    PaymentReminderDate?: string
}
export type lddGlobalSessionLawyerInfo = {
    LSUCID: string,
    FirstName: string,
    LastName: string,
    StewartProfile: string,
    LLCUsername: string,
    LLCToken: string,
    TPLawyerID: string
}
export type lddGlobalSessionStaffInfo = {
    ID: string,
    Name: string,
    LocationNumber: string
}